// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { AssetErrorBoundary } from '@/asset/components/asset-error-boundary';
import { getAssetAuditEvents } from '@/audit/api/get-asset-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/assets/$assetKey/audit')({
  component: AssetAuditRoute,
});

function AssetAuditRoute() {
  const { assetKey } = Route.useParams();

  return (
    <AssetErrorBoundary>
      <AssetAuditContent assetKey={assetKey} />
    </AssetErrorBoundary>
  );
}

function AssetAuditContent(props: { assetKey: string }) {
  const { data } = useSuspenseQuery({
    queryKey: ['asset', props.assetKey, 'audit'],
    queryFn: () => getAssetAuditEvents(props.assetKey),
    retry: false,
  });

  return (
    <HardfinTabCardWrapper title="Audit log">
      <Stack spacing={2} paddingTop={2}>
        {data.events.map((event) => (
          <AuditEventListItem key={event.id} event={event} />
        ))}
      </Stack>
    </HardfinTabCardWrapper>
  );
}
